import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconDownload = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-label="IconDownload"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M8 11.75a.8.8 0 0 1-.322-.07 1 1 0 0 1-.275-.19L3.536 7.642a.8.8 0 0 1-.25-.617.93.93 0 0 1 .298-.64.8.8 0 0 1 .609-.25c.237.01.462.108.633.273l2.317 2.35V.879A.84.84 0 0 1 7.405.26a.85.85 0 0 1 .621-.26.81.81 0 0 1 .609.26.86.86 0 0 1 .25.618v7.88l2.365-2.35a.9.9 0 0 1 .958-.215.8.8 0 0 1 .283.192.92.92 0 0 1 .263.64.84.84 0 0 1-.263.618L8.624 11.49a.9.9 0 0 1-.287.19.9.9 0 0 1-.333.071zM1.745 16a1.68 1.68 0 0 1-1.219-.522A1.66 1.66 0 0 1 0 14.268v-2.54a.84.84 0 0 1 .263-.618.85.85 0 0 1 .62-.261.81.81 0 0 1 .61.261.86.86 0 0 1 .25.617v2.54h12.514v-2.54a.84.84 0 0 1 .263-.617.85.85 0 0 1 .62-.261.81.81 0 0 1 .61.261.86.86 0 0 1 .25.617v2.54a1.66 1.66 0 0 1-.525 1.211 1.68 1.68 0 0 1-1.218.522z" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconDownload);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
